<ng-container *transloco="let t; read:'permit.team.search'">
    <div class="modal">
        <div class="modal__text modal__text--from-translation" [innerHTML]="t('certificateIdentifierHelpText')">
        </div>

        <div class="modal__actions">
            <button class="modal__actions__cancel" type="button" (click)="closeModal()">{{ t("close") }}</button>
        </div>
    </div>
</ng-container>
